import React, { ReactElement } from 'react';
import { Hotkey, HotkeyBadgeWrapper, Text } from './HotkeyBadgeStyles';

interface IProps {
  hotkey: string | ReactElement;
}

export const HotkeyBadge: React.FC<IProps> = (props) => {
  const { hotkey } = props;

  return (
    <HotkeyBadgeWrapper className='hotkey-badge'>
      <Text>Key</Text>
      <Hotkey>{hotkey}</Hotkey>
    </HotkeyBadgeWrapper>
  );
};
